<template>
  <div class="navbar main">
    <el-image
      :src="require('@/assets/images/SHOWALL-LOGO.png')"
      class="left-logo"
    ></el-image>
    <div class="right-menu">
      <el-menu
        :default-active="this.$route.path"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        background-color="transparent"
        mode="horizontal"
        :router="true"
      >
        <el-menu-item
          v-for="route in routes"
          :index="route.path"
          :key="route.path"
        >
          <template v-if="isLogin && route.path == '/user'">
            <el-dropdown class="avatar-container" trigger="hover">
              <div class="avatar-wrapper">
                <span>{{ name }}</span>
                <i class="el-icon-caret-bottom" />
              </div>
              <el-dropdown-menu slot="dropdown" class="user-dropdown">
                <!-- <router-link to="/user/wallet">
                  <el-dropdown-item>我的钱包</el-dropdown-item>
                </router-link> -->
                <!-- <router-link to="/user/meterial">
                  <el-dropdown-item>我的资料</el-dropdown-item>
                </router-link> -->
                <el-dropdown-item divided @click.native="logout">
                  <span style="display:block;">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template v-else>{{ route.meta.title }}</template>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import variables from "@/styles/variables.scss";

export default {
  components: {},
  computed: {
    ...mapGetters(["avatar", "name", "isLogin"]),
    routes: function() {
      return this.pcRoutes.filter(item => {
        return !item.meta.hidden;
      });
    }
  },
  created() {
    let pcRoutes = this.$router.options.routes.find(route => route.path == "/")
      .children;
    let splicePath = "";
    if (this.isLogin) {
      splicePath = "/login";
    } else {
      splicePath = "/user";
    }
    let pathIndex = pcRoutes.findIndex(route => route.path == splicePath);
    if (pathIndex != -1) pcRoutes[pathIndex].meta.hidden = true;
    pcRoutes.reverse();
    this.pcRoutes = pcRoutes;
    // console.log(pcRoutes);
  },
  data() {
    return {
      variables,
      defaultPath: "",
      pcRoutes: []
    };
  },
  methods: {
    async logout() {
      await this.$store.dispatch("user/logout").then(res => {
        this.$router.push("/login");
        setTimeout(() => {
          location.reload();
        }, 500);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  position: relative;
  height: 60px;
  line-height: 60px;
  overflow: hidden;
  .avatar-wrapper {
    // color: #fff;
    // i {
    //   color: #fff;
    // }
  }
  .left-logo {
    padding-top: 15px;
    height: 30px;
    box-sizing: content-box;
  }

  &.is-login {
    background-color: #fff;
    color: #353535;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.1);
    .el-menu.el-menu--horizontal {
      .el-menu-item {
        color: #353535 !important;
      }
    }
    .avatar-wrapper {
      color: #353535;
      i {
        color: #353535;
      }
    }
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 60px;
    display: flex;
    &:focus {
      outline: none;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: 0;
      .el-menu-item {
        &:hover {
          // color: #ffdb39 !important;
          border-bottom: 2px solid #f00 !important;
          background-color: #ffd1d3 !important;
        }
        &.is-active {
          color: #ff3427 !important;
          border-bottom-color: #f00 !important;
          background-color: #ffd1d3 !important;
        }
      }
    }

    .avatar-container {
      // margin-right: 30px;
      .avatar-wrapper {
        position: relative;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/components/Navbar.vue